module.exports = __webpack_public_path__ + "static/media/book1.42fd0a61.png";